export const styles = {
    modalHeader: {
        padding: '20px 24px 16px',
        borderBottom: '1px solid #e5e7eb',
        background: '#fff',
    },
    modalTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    titleIcon: {
        width: '34px',
        height: '34px',
        borderRadius: '8px',
        background: '#f0fdf4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    titleText: {
        fontSize: '17px',
        fontWeight: '700',
        color: '#111827',
    },
    countBadge: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '2px 10px',
        marginLeft: '4px',
    },
    modalBody: {
        padding: '20px 24px',
        maxHeight: '460px',
        overflow: 'auto',
        background: '#fafafa',
    },
    tableWrapper: {
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
        background: '#fff',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13px',
    },
    theadRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
    },
    th: {
        padding: '11px 14px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        whiteSpace: 'nowrap',
    },
    row: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
    },
    td: {
        padding: '11px 14px',
        color: '#374151',
        whiteSpace: 'nowrap',
        fontSize: '13px',
        verticalAlign: 'middle',
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    avatar: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontWeight: '700',
        flexShrink: 0,
    },
    connectedBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#dcfce7',
        color: '#15803d',
        borderRadius: '20px',
        fontSize: '11.5px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
    },
    notConnectedBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f3f4f6',
        color: '#6b7280',
        borderRadius: '20px',
        fontSize: '11.5px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
    },
    scanQrBtn: {
        padding: '5px 14px',
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: 'transparent',
        border: '1.5px solid #1a7d3e',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease, color 0.15s ease',
    },
    disconnectBtn: {
        padding: '5px 12px',
        fontSize: '12px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#dc2626',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 0',
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        padding: '14px 24px',
        borderTop: '1px solid #e5e7eb',
        background: '#fff',
    },
    btnPrimary: {
        padding: '9px 20px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
    },
};
